import { render, staticRenderFns } from "./TheLeftPanelDropzone.vue?vue&type=template&id=1d6fa7d0&scoped=true&"
import script from "./TheLeftPanelDropzone.vue?vue&type=script&lang=ts&"
export * from "./TheLeftPanelDropzone.vue?vue&type=script&lang=ts&"
import style0 from "./TheLeftPanelDropzone.vue?vue&type=style&index=0&id=1d6fa7d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6fa7d0",
  null
  
)

export default component.exports